module.exports = __webpack_public_path__ + "img/kyIcon_4.e5be3740.png";